import { AppLayout } from "@/components/layout/AppLayout";
import { SupportContactSection } from "./SupportContactSection";
import { LegalLinksSection } from "./LegalLinksSection";
import { MaintenanceSection } from "./MaintenanceSection";
import { BookingDefaultsSection } from "./BookingDefaultsSection";
import { AmenitiesSection } from "./AmenitiesSection";
import { PricingSettingsSection } from "./PricingSettingsSection";

export const PlatformSettingsPage = () => (
  <AppLayout title="Platform Settings">
    <div className="space-y-5">
      <MaintenanceSection />
      <PricingSettingsSection />
      <SupportContactSection />
      <LegalLinksSection />
      <BookingDefaultsSection />
      <AmenitiesSection />
    </div>
  </AppLayout>
);

export default PlatformSettingsPage;
